export async function importAesKey(rawKey) {
    if (rawKey.length !== 32)
        throw new Error("AES-256-GCM requires 32-byte key");
    return crypto.subtle.importKey("raw", rawKey, "AES-GCM", false, ["encrypt", "decrypt"]);
}
/** Returns nonce(12) || ciphertext || tag(16). */
export async function aesGcmEncrypt(key, plaintext) {
    const nonce = crypto.getRandomValues(new Uint8Array(12));
    const ct = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: nonce }, key, plaintext));
    const out = new Uint8Array(nonce.length + ct.length);
    out.set(nonce, 0);
    out.set(ct, nonce.length);
    return out;
}
export async function aesGcmDecrypt(key, packed) {
    if (packed.length < 12 + 16)
        throw new Error("aes-gcm: ciphertext too short");
    const nonce = packed.subarray(0, 12);
    const ct = packed.subarray(12);
    const pt = await crypto.subtle.decrypt({ name: "AES-GCM", iv: nonce }, key, ct);
    return new Uint8Array(pt);
}
//# sourceMappingURL=aesgcm.js.map